import React from 'react'

interface HealthIconProps {
	width?: number | string
	height?: number | string
	color?: string
	onClick?: () => void
	style?: React.CSSProperties
}

const HealthIcon: React.FC<HealthIconProps> = ({
	width = 16,
	height = 16,
	color = '#7F7F84',
	onClick,
	style,
}) => (
	<svg
		width={width}
		height={height}
		viewBox='0 0 16 16'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		onClick={onClick}
		style={{ cursor: onClick ? 'pointer' : 'default', ...style }}
	>
		<path
			d='M2.69345 4.3746C2.66139 3.76362 3.08302 3.22923 3.67658 3.08085L7.67658 2.08085C7.8889 2.02777 8.11102 2.02777 8.32334 2.08085L12.3233 3.08084C12.9169 3.22923 13.3385 3.76362 13.3065 4.3746C13.0475 9.30876 10.9497 12.2215 8.58863 13.6709C8.22698 13.8929 7.77294 13.8929 7.41128 13.6709C5.05021 12.2215 2.95243 9.30876 2.69345 4.3746Z'
			stroke={color}
			strokeWidth='1.33333'
		/>
		<path
			d='M7.99996 6V8.66667M9.33329 7.33333H6.66663'
			stroke={color}
			strokeWidth='1.33333'
			strokeLinecap='round'
		/>
	</svg>
)

export default HealthIcon
